import { ReactNode } from 'react';

import TitledCard from '@/components/ui/TitledCard';
import cn from '@/utils/cn';

import { useLingui } from '@lingui/react';

interface CheckoutSummaryProps {
  note?: ReactNode;
  children: ReactNode;
  className?: string;
}

const CheckoutSummary = ({
  note,
  children,
  className,
}: CheckoutSummaryProps) => {
  const { i18n } = useLingui();

  return (
    <TitledCard
      title={i18n.t('Podsumowanie')}
      className={cn('p-[14px] md:p-6', className)}
    >
      <div className="flex w-full flex-col gap-3">{children}</div>
      {note}
    </TitledCard>
  );
};

export default CheckoutSummary;
